import { Button } from "@jmurga97/components";
import { Link } from "@tanstack/react-router";

export function NotFoundState() {
  return (
    <main className="px-ming-4 sm:px-ming-6">
      <div className="ming-empty mx-auto w-full">
        <p className="ming-eyebrow">Not found</p>
        <h1 className="text-heading font-medium">Document not found</h1>
        <p>The link may have expired or the document is no longer published.</p>
        <Button nativeButton={false} render={<Link to="/" />}>
          Back to index
        </Button>
      </div>
    </main>
  );
}
